export const DEFAULT_NOTIFICATION_DAYS = 14;
